import React, { lazy } from 'react';
import IconGamePerformance from '@/assets/images/menu/icon-game-performance.react.svg?react';
import IconGamePlayerAnalysis from '@/assets/images/menu/icon-game-player-analyze.react.svg?react';
import IconPerformance from '@/assets/images/menu/icon-performance.react.svg?react';
import { getProductId, isAndroid, isIOS, isWindows } from '@/infrastructure/product-info';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { Toggle } from '@/presentation/components/toggle/toggle';
import { stores } from '@/presentation/store';
import { IRouteConfig } from '../types';

/**
 * 判断产品类型是否为游戏
 * 游戏类型的 type 值范围：15-22
 * - 15: 动作冒险
 * - 16: 飞行射击
 * - 17: 角色扮演
 * - 18: 经营策略
 * - 19: 体育竞速
 * - 20: 网络游戏
 * - 21: 益智游戏
 * - 22: 休闲娱乐
 */
export const isGameType = (type?: number): boolean => type !== undefined && type >= 15 && type <= 22;

// 缓存七彩石校验结果
let cachedToggleEnabled: boolean | null = null;

// 模块加载时立即请求七彩石配置
void (async () => {
  try {
    const toggle = new Toggle();
    cachedToggleEnabled = await toggle.isEnable('gamePerformance', ['appId'], {
      appId: getProductId(),
    });
  } catch {
    cachedToggleEnabled = false;
  }
})();

/**
 * 路由校验器 —— 从 Store 同步读取产品信息 + 七彩石开关判断
 */
const gamePerformanceValidator = (): boolean => {
  const { product, loaded } = stores.ProductStore;
  if (!loaded) return false;
  if (!isGameType(product?.type)) return false;
  if (!isAndroid() && !isIOS() && !isWindows()) return false;
  if (!cachedToggleEnabled) return false;
  return true;
};

export const gamePerformanceRoutes = (): IRouteConfig[] => [
  {
    path: '/game-performance/metric-analysis',
    name: '游戏性能',
    icon: <MenuIcon icon={IconGamePerformance} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/game-performance/metric-analysis')),
    validator: gamePerformanceValidator,
  },
  {
    path: '/game-performance/user-analysis',
    name: '玩家分析',
    icon: <MenuIcon icon={IconGamePlayerAnalysis} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/game-performance/user-analysis')),
    validator: gamePerformanceValidator,
  },
  {
    path: '/game-performance/user-detail',
    name: '对局详情',
    icon: <MenuIcon icon={IconPerformance} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/game-performance/user-detail')),
    hideInMenu: true,
    validator: gamePerformanceValidator,
  },
];

export default gamePerformanceRoutes;
